import AxiosConfig from '../utils/AxiosConfig';

/** Offset del número de orden mostrado (web). ID interno 1,2,3... → se muestra 10001, 10002... */
export const SITES_ORDER_DISPLAY_OFFSET = 13500;

class SitesOrderService {
  /**
   * Obtener todas las órdenes
   * GET /sites/orders
   */
  async getOrders(params = {}) {
    try {
      const { page = 1, pageSize = 20, shippingStatus, paymentStatus, search } = params;
      const queryParams = new URLSearchParams();
      queryParams.append('page', page.toString());
      queryParams.append('pageSize', pageSize.toString());
      if (shippingStatus) queryParams.append('shippingStatus', shippingStatus);
      if (paymentStatus) queryParams.append('paymentStatus', paymentStatus);
      if (search) queryParams.append('search', search);

      const response = await AxiosConfig.get(`/sites/orders?${queryParams.toString()}`);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('Error fetching orders:', error);
      throw error;
    }
  }

  /**
   * Obtener una orden por ID
   * GET /sites/orders/{id}
   * Normaliza preferredDay/preferredTime por si la API devuelve snake_case.
   */
  async getOrderById(orderId) {
    try {
      const response = await AxiosConfig.get(`/sites/orders/${orderId}`);
      const raw = response.data?.data ?? response.data;
      if (raw && typeof raw === 'object') {
        return {
          ...raw,
          preferredDay: raw.preferredDay ?? raw.preferred_day ?? null,
          preferredTime: raw.preferredTime ?? raw.preferred_time ?? null
        };
      }
      return raw;
    } catch (error) {
      console.error('Error fetching order:', error);
      throw error;
    }
  }

  /**
   * Actualizar estado de pago
   * PATCH /sites/orders/{id}/payment-status
   * @param {number} orderId
   * @param {string} status - PENDING | COMPLETED
   * @param {string} [terminalCode] - Código del terminal donde se cobró (requerido al marcar COMPLETED en órdenes efectivo)
   * @param {string} [paymentMethod] - Método de pago final real: CASH | TRANSFER | MERCADOPAGO
   */
  async updatePaymentStatus(orderId, status, terminalCode = null, paymentMethod = null) {
    try {
      const body = { status };
      if (terminalCode != null && terminalCode !== '') body.terminalCode = terminalCode;
      if (paymentMethod != null && paymentMethod !== '') body.paymentMethod = paymentMethod;
      const response = await AxiosConfig.patch(`/sites/orders/${orderId}/payment-status`, body);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('Error updating payment status:', error);
      throw error;
    }
  }

  /**
   * Actualizar estado de envío
   * PATCH /sites/orders/{id}/shipping-status
   */
  async updateShippingStatus(orderId, status) {
    try {
      const response = await AxiosConfig.patch(`/sites/orders/${orderId}/shipping-status`, {
        status
      });
      return response.data?.data || response.data;
    } catch (error) {
      console.error('Error updating shipping status:', error);
      throw error;
    }
  }

  /**
   * Anular venta web (devolución stock; si estaba pagada, emite NC)
   * POST /sites/orders/{id}/cancel
   */
  async cancelOrder(orderId) {
    try {
      const response = await AxiosConfig.post(`/sites/orders/${orderId}/cancel`);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('Error canceling order:', error);
      throw error;
    }
  }

}

export default new SitesOrderService();
